import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import SmallButton from "../../components/Buttons/SmallButton";
import PrimaryButton from "../../components/Buttons/PrimaryButton";
import { AddIcon } from "../../components/Icons";
import { setPageTitle } from "../../helper/metaDataHelper";
import CustomTransition from "../../components/CustomTransition";
import { getAllSubAccounts } from "../../redux/actions/home/ClientSubAccount";
import SubAccountsTable from "../../components/ClientSubAccount/SubAccountsTable";
import SubAccountSideBar from "../../components/ClientSubAccount/SubAccountSideBar";
import EmptySelectionPlaceholder from "../../components/Empty/EmptySelectionPlaceholder";
import LoadingSpinner from "../../components/Common/LoadingSpinner";
import { scrollToTopWithEase } from "../../helper/ScrollHelper";
import { useModules } from "../../hooks";

const SubAccountList = () => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const parentClientId = localStorage.getItem("parentClientId");
  const isSumSubEnabled = useModules("Sumsub"); 

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const { userInfo } = useSelector((state) => state.userInfo);

  useEffect(() => {
    sessionStorage.removeItem("subAccountFlow");
    sessionStorage.removeItem("subAccountFlowSumSub");
  }, []);

  useEffect(() => {
    setPageTitle("Sub Accounts");
    fetchSubAccounts();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchSubAccounts = async () => {
    setLoading(true);
    try {
      const response = await dispatch(getAllSubAccounts());
      if (response && response.success) {
        setAccounts(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch sub accounts", error);
    }
    setLoading(false);
  };

  const handleAddSubAccount = () => {
    navigate("/create-sub-account", {
      state: { isSubAccount: true, parentClientId: parentClientId },
    });
  };

  const handleRowClick = (account) => {
    scrollToTopWithEase();
    setSelectedAccount(account);
    setShowSidebar(true);
  };

  return (
    <main>
      <div className="max-w-[1024px] mx-auto px-4 min-h-screen">
        <div className="flex flex-col md:w-[82px]">
          <SmallButton href="/" text="Back" back={true} />
        </div>

        <div
          className={`flex md:flex-row flex-col md:items-center justify-between py-2 md:py-4 transition-all duration-500 ease-in-out ${
            showSidebar ? "md:w-[572px]" : "w-[700px]"
          }`}
        >
          <h1 className="!text-2xl page-title">Sub Accounts</h1>
          <div className="flex space-x-3 py-3">
            <div className="md:block block">
              <PrimaryButton
                text="Add Sub Account"
                icon={<AddIcon className="add-sub-account-list" />}
                onClick={handleAddSubAccount}
              />
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-center gap-3">
          <div
            className={`transition-all duration-500 ease-in-out 
              ${showSidebar ? "md:w-[572px] hidden md:block" : "w-full"} 
              w-full sm:flex-grow mb-6 sm:mb-0 space-y-4 md:pb-5`}
          >
            {loading && accounts.length === 0 ? (
              <LoadingSpinner />
            ) : (
              <SubAccountsTable
                accounts={accounts}
                handleRowClick={handleRowClick}
                activeId={selectedAccount?.id}
                loading={loading}
                hasMore={false}
              />
            )}
          </div>

          {/* Right Side */}
          <div
            className={`
              ${showSidebar ? "w-full md:w-[350px] xl:w-[404px] block" : "hidden md:block md:w-[350px] xl:w-[404px]"}
          `}
          >
            {showSidebar && selectedAccount ? (
              <CustomTransition show={showSidebar}>
                <SubAccountSideBar
                  account={selectedAccount}
                  onClose={() => {
                    setShowSidebar(false);
                    setSelectedAccount(null);
                  }}
                  parentClientId={parentClientId}
                  isSumSubEnabled={isSumSubEnabled}
                />
              </CustomTransition>
            ) : (
              <div className="hidden md:block">
                <EmptySelectionPlaceholder />
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default SubAccountList;
